import { render, staticRenderFns } from "./PayrollMovementsTab.vue?vue&type=template&id=d39177ce&scoped=true"
import script from "./PayrollMovementsTab.vue?vue&type=script&lang=js"
export * from "./PayrollMovementsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39177ce",
  null
  
)

export default component.exports